import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from 'store'
import SentryErrorBoundary from 'components/SentryErrorBoundary'
import { initializeFp } from 'utils/gtm'
import { changeLayoutSetting } from 'app-redux/settings/actions'
import InstallPromptWrapper from './InstallPromptWrapper'
import Router from './router'
import UpdateAppWrapper from './UpdateAppWrapper'

class App extends Component {
  async componentDidMount() {
    this.setLayoutView(true)
    window.addEventListener('resize', () => {
      this.setLayoutView()
    })
  }

  componentDidUpdate(prevProps) {
    // Reinitialize facebook pixel
    if (prevProps.user !== this.props.user) {
      if (import.meta.env.PROD) {
        initializeFp(this.props.user.email)
      }
    }

    // Untuk redirect slack connect. Slack tidak bisa menerima jika ada # di urlnya
    if (window.location.pathname === '/slack-connect') {
      window.location.replace(`/#/settings/slack-connect${window.location.search}`)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setLayoutView)
  }

  setLayoutView = (load = false) => {
    const windowWidth = global.window.innerWidth
    const currentMobileState = windowWidth < 768
    const prevMobileState = store.get('app.settings.isMobileView')
    const currentTabState = windowWidth >= 768 && windowWidth <= 992
    const prevTabState = store.get('app.settings.isTabView')

    if (currentMobileState !== prevMobileState || currentTabState !== prevTabState || load) {
      this.props.onChangeLayoutSetting({
        isMobileView: currentMobileState,
        isTabView: currentTabState,
      })
    }
  }

  render() {
    const { history, user } = this.props
    const appComponent = (
      <>
        <Router history={history} />
        <UpdateAppWrapper />
        <InstallPromptWrapper />
      </>
    )

    return (
      <SentryErrorBoundary
        showDialog
        dialogOptions={{
          user: {
            name: user?.name,
            email: user?.email,
          },
        }}
      >
        {appComponent}
      </SentryErrorBoundary>
    )
  }
}

const mapStateToProps = ({ _inits: { user } }) => ({
  user,
})

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeLayoutSetting: (payload) => dispatch(changeLayoutSetting(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
